/*
 * Needs attention: the "Download CSV" columns (to_csv shape) for the tier summary, Recent Ops
 * decisions, the category split and the daily report. Pure. The issue list has its own server CSV.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import {
  DAILY_ISSUES_PAGE_SIZE,
  daily_issue_list_init,
  daily_issue_next_request,
  daily_issue_page_applied,
  daily_issue_status,
  issues_view
} from './adapters';
import { issues_params } from './params';

const PAGE = 'teacher-payments-needs-attention';

export const na_csv_name = (table, period, now) =>
  csv_file_name({ page: PAGE, table, period, now });

const dash_blank = (v) => (v === '—' ? '' : v);

const issue_counts = [
  { header: 'Open', key: 'open_count', kind: 'number' },
  { header: 'Acknowledged', key: 'acknowledged_count', kind: 'number' },
  { header: 'Resolved', key: 'resolved_count', kind: 'number' },
  { header: 'Auto-cleared', key: 'auto_cleared_count', kind: 'number' }
];

export const tier_csv_columns = [
  { header: 'Tier', key: 'label' },
  { header: 'Tier code', key: 'tier' },
  { header: 'Teachers', key: 'teachers', kind: 'number' },
  { header: 'Sessions', key: 'sessions', kind: 'number' },
  ...issue_counts,
  { header: '₹ at stake', key: 'amount_at_stake', kind: 'money' },
  { header: 'Blocks close', key: 'blocks_close', kind: 'bool' }
];

export const decision_csv_columns = [
  { header: 'Teacher', value: (d) => dash_blank(d.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Issue', key: 'label' },
  { header: 'Issue ID', key: 'issue_id', kind: 'number' },
  { header: 'Issue code', key: 'issue_code' },
  { header: 'Tier', key: 'tier_label' },
  { header: 'Decision', key: 'action_label' },
  { header: 'By', value: (d) => dash_blank(d.who) },
  { header: 'When (IST)', key: 'resolved_at', kind: 'datetime' },
  { header: 'Note', key: 'note' }
];

export const category_csv_columns = [
  { header: 'Category', key: 'label' },
  { header: 'Issue code', key: 'issue_code' },
  { header: 'Suggested action', key: 'suggested_action' },
  { header: 'Teachers', key: 'teachers', kind: 'number' },
  { header: 'Sessions', key: 'sessions', kind: 'number' },
  ...issue_counts,
  { header: '₹ at stake', key: 'amount_at_stake', kind: 'money' },
  { header: 'Blocks close', key: 'blocks_close', kind: 'bool' }
];

export const daily_line_csv_columns = [
  { header: 'Issue', key: 'label' },
  { header: 'Issue code', key: 'issue_code' },
  { header: 'Tier', key: 'tier_label' },
  { header: 'Issues', key: 'count', kind: 'number' },
  { header: 'Teachers', key: 'teachers', kind: 'number' },
  { header: '₹ at stake', key: 'amount_at_stake', kind: 'money' },
  { header: 'Months', value: (l) => (l.pay_months || []).map((m) => String(m).slice(0, 7)) }
];

// The individual issues behind one daily line (issue_row_view rows).
export const daily_issue_csv_columns = [
  { header: 'Teacher', value: (r) => dash_blank(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Pay month', value: (r) => String(r.pay_month || '').slice(0, 7) },
  { header: 'Session', value: (r) => (r.session_id === 0 ? 'Month' : r.scope_label) },
  { header: 'Session time (IST)', key: 'session_start_ist', kind: 'datetime' },
  { header: 'Session UUID', key: 'session_uuid' },
  { header: 'Issue ID', key: 'id', kind: 'number' },
  { header: 'Issue code', key: 'issue_code' },
  { header: '₹ at stake', key: 'amount_at_stake', kind: 'money' },
  { header: 'Status', key: 'status_label' }
];

/*
 * fetch_page for collect_all_pages over one daily line's issues: every page of every month the line
 * spans, in order, from the same /needs_attention/issues read as "Show more". fetch = the api call.
 */
export const daily_issue_page_reader = (fetch, line, section_key) => {
  const fetch_from = (at) => {
    const request = daily_issue_next_request(at);
    if (!request) return Promise.resolve({ rows: [], next: null });
    return fetch(
      issues_params(
        {
          pay_month: request.pay_month,
          issue_code: line.issue_code,
          status: daily_issue_status(section_key),
          sort: 'session_time',
          dir: 'asc'
        },
        DAILY_ISSUES_PAGE_SIZE,
        request.offset
      )
    ).then((data) => {
      const page = issues_view(data);
      if (!page.rows.length) {
        // an empty page ends its month whatever total it claims (no endless re-read).
        const month_index = at.month_index + 1;
        const skip = { ...at, month_index, offset: 0, done: month_index >= at.months.length };
        return skip.done ? { rows: [], next: null } : fetch_from(skip);
      }
      const next = daily_issue_page_applied({ ...at, rows: [] }, request, page);
      return { rows: page.rows, next: next.done ? null : next };
    });
  };
  return (cursor) => fetch_from(cursor || daily_issue_list_init(line.pay_months));
};
